import { concatErrors, validator } from 'nike-form-js';
import i18n from '../../../../common/i18n';
import { KYC_QUESTION_TYPE } from './KycQuestionType';

export const MULTI = {
    CHECKBOX: ['checkbox'],
    FREETEXT: ['freetext']
};
export const SINGLE = 'single';
export const FREETEXT = 'freetext';

function validateAnswersSelected(errors, value, maxAnswerNum) {
    let resErrors = errors;
    value.mapKeys((type, kyc) => {
        if (type === KYC_QUESTION_TYPE.MULTI) {
            kyc.mapKeys((questionId, options) => {
                const path = [KYC_QUESTION_TYPE.MULTI, questionId];
                const checked = options.some(value => value.getIn(MULTI.CHECKBOX));
                if (!checked) {
                    resErrors = resErrors.updateIn(path, concatErrors([i18n('nui.validation.kyc.all.required')]));
                }
                const count = options.filter(value => value.getIn(MULTI.CHECKBOX)).size;
                if (count > maxAnswerNum) {
                    resErrors = resErrors.updateIn(
                        path,
                        concatErrors([i18n('nui.validation.kyc.multi.maxAnswerNum', maxAnswerNum)])
                    );
                }
            });
            kyc?.mapKeys((questionId, options) => {
                resErrors = validateMulti(questionId, resErrors, options);
            });
        }
        if (type === KYC_QUESTION_TYPE.SINGLE) {
            kyc?.mapKeys((questionId, options) => {
                resErrors = validateSingle(questionId, resErrors, options);
            });
        }
        if (type === KYC_QUESTION_TYPE.FREETEXT) {
            kyc?.mapKeys((questionId, options) => {
                resErrors = validateFreeText(questionId, resErrors, options);
            });
        }
    });

    return resErrors;
}

function validateMulti(questionId, errors, values) {
    let resErrors = errors;
    values
        .filter(value => value.getIn(MULTI.CHECKBOX))
        .mapKeys((optionId, value) => {
            const freetext = value.getIn(MULTI.FREETEXT);
            freetext?.mapKeys((key, val) => {
                if (!val) {
                    const path = [KYC_QUESTION_TYPE.MULTI, questionId, optionId, ...MULTI.FREETEXT, key];
                    resErrors = resErrors.updateIn(path, concatErrors([i18n('nui.validation.kyc.other.required')]));
                }
            });
        });

    return resErrors;
}

function validateSingle(questionId, errors, active) {
    let resErrors = errors;
    if (!active) {
        resErrors = resErrors.updateIn(
            [SINGLE, questionId],
            concatErrors([i18n('nui.validation.kyc.single.required')])
        );
    }
    return resErrors;
}

function validateFreeText(questionId, errors, options) {
    let resErrors = errors;
    options.mapKeys((optionId, value) => {
        const freetext = value.get(FREETEXT);
        if (!freetext) {
            const path = [KYC_QUESTION_TYPE.FREETEXT, questionId, optionId, FREETEXT];
            resErrors = resErrors.updateIn(path, concatErrors([i18n('nui.validation.kyc.freetext.required')]));
        }
    });
    return resErrors;
}

export const formValidator = maxAnswerNum => validator([], validateAnswersSelected, maxAnswerNum);
